// "Confirm" beside a Size unconfirmed badge on the Customers page.
//
// Confirming the size is picking the tier the row already holds, so it goes
// through the one path that clears size_confirmation_pending: PUT
// /api/customers/:id with snowTierId present (server.js drives snow_tier_id
// and the flag off that one key). No second path, no new flag.
//
// The body is snowTierId and nothing else. The row's current tier is what its
// dropdown shows, so this writes back the same tier and clears the flag; no
// price keys, so price_snow and salt_price stay as they are. A row with no
// tier shows Custom, and confirming it sends null, the same as picking Custom.
// If the owner changes the dropdown first, that change is itself the decision
// and clears the flag; the row is reloaded with the new tier either way.
export function sizeConfirmBody(row) {
  const id = row && row.snow_tier_id != null ? parseInt(row.snow_tier_id, 10) : null;
  return { snowTierId: Number.isInteger(id) ? id : null };
}
